<template>
  <EditorNodeWrapper
    :class="['node-container', 'table-container', rowTypeClass, blockWidthClass]"
    @observe-node-visibility="$emit('observe-node-visibility', { ...$event, nodeId: node.id })"
  >
    <ProsemirrorViewerTable
      :content="jsonContent"
      :border-color="borderColor"
      :alternate-row-color="alternateRowColor"
      :header-row-background-color="headerRowBackgroundColor"
      :merge-values="mergeValues"
      :fields="fields"
      :is-pdf-viewer="isPdfViewer"
    />
  </EditorNodeWrapper>
</template>
<script setup lang="ts">
import type { Table, MergeValues, EBlockWidth, RowType } from '@getaccept/editor-lib';
import { fallbackTableContent } from '@getaccept/editor-lib';
import { computed } from 'vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
import ProsemirrorViewerTable from './ProsemirrorViewerTable.vue';

const { node, rowType } = defineProps<{
  node: Table;
  mergeValues: MergeValues;
  isPdfViewer?: boolean;
  rowType: RowType;
  blockWidthClass?: EBlockWidth;
}>();

defineEmits<{
  'observe-node-visibility': [{ nodeId: string; visible: boolean }];
}>();

const fields = computed(() => node.fields || []);

const jsonContent = computed(() => {
  const tableContent = node.content || fallbackTableContent;
  return JSON.parse(tableContent);
});

const borderColor = computed(() => node.tableStyle?.borderColor);
const alternateRowColor = computed(() => node.tableStyle?.alternateRowColor);
const headerRowBackgroundColor = computed(() => node.tableStyle?.headerRowBackgroundColor);
const rowTypeClass = computed(() => `row-type-${rowType?.toLowerCase()}`);
</script>
<style lang="scss" scoped>
@import '@getaccept/editor-lib/src/scss/editor-node';
</style>
